import React, { useState } from "react";


import {
  FaIndustry,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

function MiningNaturalResourcesPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Exploration & Surveying",
      points: [
        "Geological Survey Analyzer Agent",
        "Mineral Detection via Satellite Imagery",
        "Seismic Data Interpretation Bot",
        "AI Core Sample Classification Agent",
        "Mining Site Suitability Recommender",
      ],
    },

    {
      title: "Operations & Equipment",
      points: [
        "Autonomous Drilling Agent",
        "Excavator Efficiency Optimizer",
        "Equipment Predictive Maintenance Bot",
        "Load Haul Cycle Time Analyzer",
        "Fleet Coordination Agent",
      ],
    },

    {
      title: "Safety & Compliance",
      points: [
        "Hazard Zone Alert Agent",
        "Gas Leak Detection Bot",
        "Mine Shaft Stability Monitor",
        "Safety Protocol Compliance Checker",
        "PPE Usage Validator Agent",
      ],
    },

    {
      title: "Data & Asset Management",
      points: [
        "Asset Inventory Tracker",
        "Resource Yield Forecaster",
        "Ore Quality Estimation Agent",
        "Real-Time Production Dashboard",
        "AI Reconciliation Assistant",
      ],
    },

    {
      title: "Sustainability & Community Engagement",
      points: [
        "Carbon Emission Estimator Agent",
        "Water Usage Tracker",
        "Waste Material Segregator",
        "Biodiversity Impact Assessor",
        "Stakeholder Sentiment Analyzer",
      ],
    },
  ];

  return (
    <>

      {/* Responsive styles for this page */}
      <style>{`
        .mining-wrapper {
          background: #22c7b8;
          min-height: 100vh;
        }

        .mining-hero {
          background: #173b8f;
          width: 100%;
        }

        .mining-hero-inner {
          width: 92%;
          max-width: 1300px;
          margin: 0 auto;
          padding: 38px 0px;
        }

        .mining-hero-top {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }

        .mining-icon-box {
          width: 44px;
          height: 44px;
          background: #22c7b8;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .mining-icon-box svg {
          color: #ffffff;
          font-size: 20px;
        }

        .mining-title {
          color: #ffffff;
          font-size: 34px;
          font-weight: 700;
          margin: 0;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .mining-description {
          color: #f2f2f2;
          font-size: 15px;
          line-height: 1.9;
          max-width: 1000px;
          margin: 0;
        }

        .mining-accordion-wrap {
          width: 92%;
          max-width: 1050px;
          margin: 0 auto;
          padding: 28px 0px 50px;
        }

        .mining-card {
          background: #ffffff;
          border-radius: 8px;
          margin-bottom: 10px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .mining-card-header {
          padding: 14px 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          transition: 0.3s;
          gap: 10px;
        }

        .mining-card-header.active {
          background: #173b8f;
        }

        .mining-card-header.inactive {
          background: #ffffff;
        }

        .mining-card-title {
          margin: 0;
          font-size: 16px;
          font-weight: 700;
          font-family: "Exo", sans-serif;
          word-break: break-word;
        }

        .mining-card-title.active {
          color: #ffffff;
        }

        .mining-card-title.inactive {
          color: #173b8f;
        }

        .mining-chevron-active {
          color: #ffffff;
          font-size: 16px;
          flex-shrink: 0;
        }

        .mining-chevron-inactive {
          color: #173b8f;
          font-size: 16px;
          flex-shrink: 0;
        }

        .mining-card-content {
          padding: 18px 24px;
          background: #ffffff;
        }

        .mining-point-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 12px;
        }

        .mining-point-check {
          width: 24px;
          height: 24px;
          min-width: 24px;
          border-radius: 50%;
          background: #22c7b8;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .mining-point-check svg {
          color: #ffffff;
          font-size: 10px;
        }

        .mining-point-text {
          margin: 0;
          color: #4b5563;
          font-size: 15px;
          line-height: 1.7;
          font-weight: 500;
          word-break: break-word;
        }

        /* Tablets */
        @media (max-width: 1024px) {
          .mining-hero-inner {
            padding: 32px 0px;
          }

          .mining-title {
            font-size: 30px;
          }

          .mining-accordion-wrap {
            width: 90%;
          }
        }

        /* Small tablets / large phones */
        @media (max-width: 768px) {
          .mining-hero-inner {
            width: 90%;
            padding: 26px 0px;
          }

          .mining-icon-box {
            width: 40px;
            height: 40px;
          }

          .mining-icon-box svg {
            font-size: 18px;
          }

          .mining-title {
            font-size: 26px;
          }

          .mining-description {
            font-size: 14px;
            line-height: 1.8;
          }

          .mining-accordion-wrap {
            width: 90%;
            padding: 22px 0px 40px;
          }

          .mining-card-header {
            padding: 12px 16px;
          }

          .mining-card-title {
            font-size: 15px;
          }

          .mining-card-content {
            padding: 16px 18px;
          }
        }

        /* Mobile phones */
        @media (max-width: 480px) {
          .mining-hero-inner {
            width: 88%;
            padding: 22px 0px;
          }

          .mining-hero-top {
            gap: 10px;
            margin-bottom: 12px;
          }

          .mining-icon-box {
            width: 36px;
            height: 36px;
            border-radius: 8px;
          }

          .mining-icon-box svg {
            font-size: 16px;
          }

          .mining-title {
            font-size: 21px;
          }

          .mining-description {
            font-size: 13px;
            line-height: 1.7;
          }

          .mining-accordion-wrap {
            width: 90%;
            padding: 18px 0px 32px;
          }

          .mining-card {
            border-radius: 6px;
            margin-bottom: 8px;
          }

          .mining-card-header {
            padding: 10px 14px;
          }

          .mining-card-title {
            font-size: 14px;
          }

          .mining-card-content {
            padding: 14px 14px;
          }

          .mining-point-row {
            gap: 10px;
            margin-bottom: 10px;
          }

          .mining-point-check {
            width: 20px;
            height: 20px;
            min-width: 20px;
          }

          .mining-point-check svg {
            font-size: 9px;
          }

          .mining-point-text {
            font-size: 13.5px;
            line-height: 1.6;
          }
        }

        /* Very small phones */
        @media (max-width: 360px) {
          .mining-title {
            font-size: 18px;
          }

          .mining-card-title {
            font-size: 13px;
          }

          .mining-point-text {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="mining-wrapper">
        {/* HERO SECTION */}
        <div className="mining-hero">
          <div className="mining-hero-inner">
            <div className="mining-hero-top">
              <div className="mining-icon-box">
                <FaIndustry />
              </div>

              <h1 className="mining-title">Mining & Natural Resources</h1>
            </div>

            <p className="mining-description">
              This sector encompasses exploration, extraction, processing, and transportation of natural resources like coal, iron, copper, etc.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div className="mining-accordion-wrap">
          {sections.map((section, index) => {
            const isActive = openIndex === index;
            return (
              <div key={index} className="mining-card">
                {/* HEADER */}
                <div
                  onClick={() => toggle(index)}
                  className={`mining-card-header ${
                    isActive ? "active" : "inactive"
                  }`}
                >
                  <h2
                    className={`mining-card-title ${
                      isActive ? "active" : "inactive"
                    }`}
                  >
                    {section.title}
                  </h2>

                  {isActive ? (
                    <FaChevronUp className="mining-chevron-active" />
                  ) : (
                    <FaChevronDown className="mining-chevron-inactive" />
                  )}
                </div>

                {/* CONTENT */}
                {isActive && (
                  <div className="mining-card-content">
                    {section.points.map((point, i) => (
                      <div key={i} className="mining-point-row">
                        <div className="mining-point-check">
                          <FaCheck />
                        </div>

                        <p className="mining-point-text">{point}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default MiningNaturalResourcesPage;
